import { ICreateDiagnosticsPackagesDto, ICreateDiagnosticsPackagesResponseDto, IDiagnosticsPackages, IDiagnosticsPackagesRequestDto, IUpdateDiagnosticsPackagesDto } from "types/models/DiagnosticsPackages";
import { BaseService, IBaseService } from "./BaseServiceClass";
import { AxiosInstance } from "axios";
import { APIResponseHandler } from "utilities/ErrorHelper";
import { IResult } from "./Result";
import { DefaultRoutes } from "Routes";

export interface IDiagnosticsPackagesService extends IBaseService<IDiagnosticsPackages> {
    getDiagnoticsPackage(diagnosticsPackageId: string): Promise<any>;
    getAllDiagnosticsPackages(request: IDiagnosticsPackagesRequestDto): Promise<any>;
    createDiagnosticsPackage(request: ICreateDiagnosticsPackagesDto): Promise<IResult<ICreateDiagnosticsPackagesResponseDto>>;
    patchDiagnosticsPackage(id: string, request: IUpdateDiagnosticsPackagesDto): Promise<any>;
    getDiagnosticsPackageUrl(diagnosticsPackageId: string): Promise<string>;
}

export class DiagnosticsPackagesService extends BaseService<IDiagnosticsPackages> implements IDiagnosticsPackagesService {
    constructor(axiosInstance: AxiosInstance) {
        super(axiosInstance, 'api/diagnosticspackages');
    }

    getDiagnoticsPackage = async (diagnosticsPackageId: string): Promise<any> => {
        const response = await this._axiosInstance.get(`api/diagnosticspackages/${diagnosticsPackageId}`);
        return APIResponseHandler(response);
    }

    getAllDiagnosticsPackages = async (request: IDiagnosticsPackagesRequestDto): Promise<any> => {
        const params = new URLSearchParams({
            updatedAfter: request.updatedAfter,
            includeDeleted: request.includeDeleted.toString()
        });

        const response = await this._axiosInstance.get(`api/diagnosticspackages?${params.toString()}`);
        return APIResponseHandler(response);
    };

    createDiagnosticsPackage = async (request: ICreateDiagnosticsPackagesDto): Promise<IResult<ICreateDiagnosticsPackagesResponseDto>> => {
        const response = await this._axiosInstance.post<ICreateDiagnosticsPackagesResponseDto>(`api/diagnosticspackages/`, request);

        return APIResponseHandler(response);
    }

    patchDiagnosticsPackage = async (id: string, request: IUpdateDiagnosticsPackagesDto): Promise<any> => {
        const response = await this._axiosInstance.patch(`api/diagnosticspackages/${id}`, request);

        return APIResponseHandler(response);
    }

    getDiagnosticsPackageUrl = async (diagnosticsPackageId: string): Promise<string> => {
        const pagePath = `${DefaultRoutes.DiagnosticsPackagesPage}/?selectedDiagnosticsPackage=${diagnosticsPackageId}`.replace(/\/+/g, '/');

        const origin =
            typeof window !== 'undefined' && window.location && window.location.origin
                ? window.location.origin
                : (process.env.PUBLIC_URL || '');

        try {
            return new URL(pagePath, origin).toString();
        } catch {
            return `${origin}${pagePath}`;
        }
    }
}